module.exports = __webpack_public_path__ + "img/livepen-logo-02.f26b8484.png";